import React from 'react';
import { AppContext } from '../../context/AppContext/context';

function useDepositCheckoutForm() {
  const { dispatch, state } = React.useContext(AppContext);
  const {
    appointmentId: depositCheckoutAppointmentId,
    onRefresh,
    allowTerminal,
  } = state.depositCheckout;

  const openDepositCheckout = React.useCallback(
    (
      appointmentId: string,
      onRefreshCallback?: () => void | Promise<void>,
      options?: { allowTerminal?: boolean },
    ) => {
      dispatch({
        type: 'SET_DEPOSIT_CHECKOUT_APPOINTMENT_ID',
        payload: {
          appointmentId,
          onRefresh: onRefreshCallback,
          allowTerminal: options?.allowTerminal ?? true,
        },
      });
    },
    [dispatch],
  );

  const closeDepositCheckout = React.useCallback(() => {
    dispatch({
      type: 'SET_DEPOSIT_CHECKOUT_APPOINTMENT_ID',
      payload: {
        appointmentId: null,
        onRefresh: undefined,
        allowTerminal: true,
      },
    });
  }, [dispatch]);

  return {
    depositCheckoutAppointmentId,
    onRefresh,
    allowTerminal,
    openDepositCheckout,
    closeDepositCheckout,
  };
}

export default useDepositCheckoutForm;
